<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Good Time Coming</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h3 class="books-by-head"><em>Recent Titles by C. S. Harris</em></h3>
<p> </p>
<p class="books-by-text">GOOD TIME COMING *</p>
<p> </p>
<p class="books-by-text"><em>Sebastian St. Cyr Mysteries</em></p>
<p> </p>
<p class="books-by-text">WHAT ANGELS FEAR</p>
<p class="books-by-text">WHEN GODS DIE</p>
<p class="books-by-text">WHY MERMAIDS SING</p>
<p class="books-by-text">WHERE SERPENTS SLEEP</p>
<p class="books-by-text">WHAT REMAINS OF HEAVEN</p>
<p class="books-by-text">WHERE SHADOWS DANCE</p>
<p class="books-by-text">WHEN MAIDENS MOURN</p>
<p class="books-by-text">WHAT DARKNESS BRINGS</p>
<p class="books-by-text">WHY KING CONFESS</p>
<p class="books-by-text">WHO BURIES THE DEAD</p>
<p class="books-by-text-space-after">WHEN FALCONS FALL</p>
<p> </p>
<p class="books-by-text"><span class="small"><em>* available from Severn House</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?0977c3b9